import type React from 'react';
import {
    CATEGORY_FILTER_SCOPE,
    useShortcutScope,
} from '@/components/shortcuts';

/**
 * Pushed only while the category filter's popover is open, suspending the
 * rest of the `seller` scope so no other sale-screen shortcut fires
 * underneath it. A named sibling of `CategoryFilter.tsx`, like
 * `VariantPickerScope`.
 */
export const CategoryFilterScope: React.FC = () => {
    useShortcutScope(CATEGORY_FILTER_SCOPE);
    return null;
};
